import Vue from 'vue'
import {doGet, doPut, ProduktRESTHelper, SAMPLE_PRODUCT_TYPE_ID} from "classes/api.js";
import {translatePrj} from "classes/vue-dict-filter";

import {AUFLAGE_ZAHL} from "components/OptionGroupMain.vue";
import {LIEFERART_OPTIONID} from "components/OptionGroupProduction.vue";
import MysignGlobals from "mixins/mysignGlobals"
import ProductConfigPayload from "mixins/ProductConfigPayload";
import UpdateItemMixin from "pages/mixins/UpdateItemMixin";

export default {
    mixins: [MysignGlobals, UpdateItemMixin, ProductConfigPayload],
    props: {
        // Initial config is not the same as default config.
        // Initial Config is used when product is loaded via:
        // - Change / Duplicate Product in Basket
        // - last Order ("Order again")
        // - Saved orders
        initialConfig: {
            type: Object,
            required: false
        },
        initialAddresses: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            globalConfig: window.FlyerlineConfig,
            prices: 0,
            sent: '',
            files: [],
            customizationInvalid: '',
            optionsService: {},
        };
    },
    provide() {
        return {
            addToBasket: this.addToBasket,
            globalConfig: this.globalConfig,
            versandAufteilungPreis: window.FlyerlineConfig.versandaufteilungPreis,
            dynamicValues: this.dynamicValues,
            optionsService: this.optionsService,
        }
    },
    beforeCreate() {
        this.dynamicValues = Vue.observable({versandtermine: {}})
    },
    methods: {
        // 'override' this method if necessary
        shouldLoadFilesForBasketItem(){
            return true;
        },
        loadFilesForBasketItem: function () {
            if( this.shouldLoadFilesForBasketItem() ) {
                doGet("/api/prj/uploadfiles/" + this.updateItem + ".de.json").then(resp => {
                    resp.uploadFiles.forEach(file => {
                        this.files.push(
                            {
                                name: file.name,
                                id: file.id,
                                status: 1,
                                url: file.url,
                                generated: file.generated
                            }
                        )
                    })
                })
            }
        },
        // 'override' this method if necessary
        beforeAddToBasket(){
            return Promise.resolve()
        },
        addToBasket() {
            if (this.customizationInvalid) {
                return;
            }
            this.beforeAddToBasket().then(()=> {


                if (this.updateItem) {
                    this.updateBasketItem(configPayload)
                        .then(this.configuratorService.navigateToBasket )
                } else {
                    this.configuratorService.addToBasket()
                        .then(this.configuratorService.navigateToBasket )
                }
            })

        },
        updatePrice() {
            // if (!this.customizationInvalid) {
            //     let data = this.getCurrentConfigurationPayload(this.files);
            //     data.auflageId = this.optionsService.values[AUFLAGE_ZAHL]
            //
            //     this.helper.getPrice(data)
            //         .then(response => {
            //             this.prices = response[this.optionsService.values[AUFLAGE_ZAHL]]
            //             this.dynamicValues.versandtermine = this.prices.deliveryText
            //             window._dataLayer_configuredPrice = this.prices.exclVat.split(' ')[1];
            //         })
            //         .catch(xhr => {
            //             this.prices = [];
            //             console.log("ERROR: Failed to load product conf price!")
            //         });
            //
            // }
        },
        updateCanPutToBasket() {
            // this.customizationInvalid =
            //     [this.someFileNotReady(), this.isAddressesNotValid(), this.optionsService.isConfigInvalid()]
            //         .filter(v => v).join('\n')
        },
        someFileNotReady() {
            if (this.files.some(file => file.status !== 1))
                return translatePrj('uploadfileUploadInProgress')
            return ""
        },
        update() {
            this.updateCanPutToBasket()
            this.updatePrice()
        },
    },
    watch: {
        individualAuflage() {
            this.update()
        },
        optionsService: {
            handler() {
                this.update()
            },
            deep: true
        },
        files: {
            handler() {
                this.update()
            },
            deep: true
        },
        updateItem: {
            handler() {
                this.loadFilesForBasketItem();
            }
        }
    },
    mounted() {
        this.helper = new ProduktRESTHelper(window.FlyerlineConfig.product_key);

        this.update();
    }
}

